import React, { FC } from "react";
import { Container, EventsAmount, EventsSubtitle } from "./MoaDashboard.styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Skeleton } from "@mui/material";

interface EventCountProps {
  label: string;
  count?: number;
  isLoading: boolean;
  testId?: string;
}

const EventCount: FC<EventCountProps> = (
    {
      label,
      count,
      isLoading,
      testId
    }
) => {
  const muiTheme = createTheme();
  return (
      <Container>
        <EventsAmount data-testid={testId}>
          {isLoading ?
              <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
                <Skeleton
                    variant="text"
                    animation="wave"
                    sx={{ width: '32%', height: '30px' }}
                    key={'menu-counter-mui-skeleton'}
                />
              </ThemeProvider>
              :
              <>{count ?? 0}</>
          }
        </EventsAmount>
        <EventsSubtitle>
          {label}
        </EventsSubtitle>
      </Container>
  )
}

export default EventCount;